<template>
    <!-- <FIApps /> -->
    <router-view />
</template>

<script>
export default {
    name: "App",
    mounted() {
        document.title = "Q2 Mobile Apps";
    },
};
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=LINE+Seed+JP&family=Noto+Sans+Syriac:wght@100..900&display=swap');

body {
    margin: 0;
    max-width: 100%;
    overflow-x: hidden;
    font-family: "LINE Seed JP", sans-serif;
}

* {
  overflow-wrap: break-word;
  word-break: break-word;
}

</style>
